<template>
  <div>
    <v-app-bar
      fixed
      color="#F7FAFECC"
      style="
      backdrop-filter: blur(20px);
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
    ">
      <v-toolbar-title class="logo">
        <ConnectLogo class="connect-logo" @click.native="onClickNishikaLogo" />
      </v-toolbar-title>
      <v-toolbar-items>
        <TextButton :href="toNishika('/competitions')" bold>
          {{label("competitions")}}
        </TextButton>
        <TextButton to="/" bold>
          {{label("jobs")}}
        </TextButton>
        <TextButton to="/fukugyo" bold>
          Fukugyo
        </TextButton>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <TextButton v-on="on" right-icon="mdi-chevron-down" bold>
              {{label("others")}}
            </TextButton>
          </template>
          <v-list>
            <v-list-item :href="toNishika('/faq')">
              <v-list-item-title>
                {{label("faq")}}
              </v-list-item-title>
            </v-list-item>
            <v-list-item :href="toNishika('/inquiry')">
              <v-list-item-title>
                {{label("inquiry")}}
              </v-list-item-title>
            </v-list-item>
            <v-list-item href="https://info.nishika.com/">
              <v-list-item-title>
                {{label("company")}}
              </v-list-item-title>
            </v-list-item>
            <v-list-item href="https://info.nishika.com/contents">
              <v-list-item-title>
                お役立ち資料
              </v-list-item-title>
            </v-list-item>
            <v-list-item href="https://h1matsuda.substack.com/">
              <v-list-item-title>
                AI News Letter
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-spacer />
      <v-btn
        v-if="!loggedIn"
        color="primary"
        outlined
        class="font-weight-bold mx-2"
        href="https://info.nishika.com/connect-cl/org"
      >
        {{label("toClient")}}
      </v-btn>
      <div v-if="enableLocaleSwitch">
        <v-menu offset-y>
          <template v-slot:activator="{on}">
            <TextButton v-on="on" left-icon="mdi-earth" right-icon="mdi-chevron-down"/>
          </template>
          <v-list>
            <v-list-item @click="onChangeLangJapanese" :class="langJaClass">
              {{label("langJapanese")}}
            </v-list-item>
            <v-list-item @click="onChangeLangEnglish" :class="langEnClass">
              {{label("langEnglish")}}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-toolbar-items v-if="!loading && !maintenance">
        <template v-if="loggedIn">
          <TextButton @click="onClickDashboard">
            <v-badge v-if="countUnReadOffers > 0" overlap color="error">
              <template v-slot:badge>{{countUnReadOffers}}</template>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-badge>
            <v-icon v-else>mdi-view-dashboard</v-icon>
          </TextButton>
          <TextButton to="/messages">
            <v-badge v-show="showMessageBadge" overlap color="error">
              <template v-slot:badge>{{candidateUnreadCountTotal}}</template>
              <v-icon>mdi-email</v-icon>
            </v-badge>
            <v-icon v-show="!showMessageBadge">mdi-email</v-icon>
          </TextButton>
          <TextButton @click="onClickMypage">
            <v-icon>mdi-account-box</v-icon>
          </TextButton>
          <TextButton @click="openNotificationDialog()">
            <v-badge v-show="showNotificationBadge" overlap color="error">
              <template v-slot:badge>{{notReadNotificationNumber}}</template>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
            <v-icon v-show="!showNotificationBadge">mdi-bell</v-icon>
          </TextButton>
          <v-dialog v-model="showNotificationDialog" max-width="50%" scrollable @click:outside="closeNotificationDialog">
            <NotificationPage :items="notifications" :close="closeNotificationDialog" />
          </v-dialog>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <TextButton icon v-on="on">
                <UserImage icon :src="userIcon"/>
              </TextButton>
            </template>
            <AccountMenu :user="user" />
          </v-menu>
        </template>
        <template v-else>
          <v-toolbar-items v-if="!loggedIn">
            <TextButton left-icon="mdi-login" bold @click="login" class="mx-2">
              {{label("register")}} / {{label("login")}}
            </TextButton>
          </v-toolbar-items>
        </template>
      </v-toolbar-items>
  
      <DevBadge style="position: absolute; right: 9px; top: 70px" />
    </v-app-bar>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import ConnectLogo from "../atoms/ConnectLogo";
  import TextButton from "../atoms/TextButton";
  import UserImage from "../atoms/UserImage";
  import AccountMenu from "./AccountMenu";
  import ComponentMixin from "../ComponentMixin";
  import _size from "lodash/size"
  import _filter from "lodash/filter"
  import ApiMixin from "../../ApiMixin";
  import NotificationPage from "@/components/pages/user/NotificationPage"
  import _ from "lodash";
  import DevBadge from '../molecules/DevBadge.vue'

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "organism",
    name: "NavBar",
    data () {
      return {
        showNotificationDialog: false,
      }
    },
    created () {
      const locale = localStorage.getItem('locale');
      if (locale) {
        this.$i18n.locale = locale;
      } else {
        this.onChangeLangJapanese();
      }
    },
    computed: {
      ...mapGetters("user", ["user", "notifications", "countUnReadOffers"]),
      ...mapGetters("message", ["candidateUnreadCountTotal"]),
      loading () {
        return this.$auth.loading
      },
      maintenance () {
        return process.env.VUE_APP_MAINTE
      },
      loggedIn () {
        return this.$auth.isAuthenticated
      },
      notReadNotificationNumber () {
        return _size(_filter(this.notifications, notif => !notif.isRead));
      },
      showNotificationBadge () {
        return this.notReadNotificationNumber > 0;
      },
      showMessageBadge () {
        return this.candidateUnreadCountTotal > 0;
      },
      userIcon () {
        return this.user.competition ? this.user.competition.icon : null
      },
      langJaClass () {
        return this.$i18n.locale === 'ja' ? 'activeLang' : '';
      },
      langEnClass () {
        return this.$i18n.locale === 'en' ? 'activeLang' : '';
      },
      enableLocaleSwitch () {
        return process.env.VUE_APP_ENABLE_LOCALE_SWITCH === "true";
      }
    },
    methods: {
      ...mapActions("user", ["updateNotificationsIsRead"]),
      login () {
        localStorage.setItem('nishika_redirect', window.location.href)
        this.$auth.loginWithRedirect({
          ui_locales: this.$i18n.locale,
        })
      },
      onChangeLangJapanese () {
        this.$i18n.locale = 'ja';
        localStorage.setItem('locale', 'ja');
        this.loadConsts('ja');
      },
      onChangeLangEnglish () {
        this.$i18n.locale = 'en';
        localStorage.setItem('locale', 'en');
        this.loadConsts('en');
      },
      openNotificationDialog() {
        this.showNotificationDialog = true
      },
      onClickNishikaLogo() {
        const isLoggedIn = this.$auth.isAuthenticated
        if (isLoggedIn) {
          window.location.href = this.toProfile('/dashboard')
        } else {
          window.location.href = this.toNishika('/')
        }
      },
      onClickMypage () {
        window.location.href = this.toProfile('/mypage')
      },
      onClickDashboard() {
        window.location.href = this.toProfile('/dashboard')
      },
      closeNotificationDialog () {
        this.showNotificationDialog = false
        _.forEach(this.notifications, notification => {
          if (!notification.isRead) {
            this.saveUserNotificationIsRead(this.user.id, notification.id, true)
          }
        });
      },
    },
    components: {
      DevBadge,
      ConnectLogo,
      TextButton,
      UserImage,
      AccountMenu,
      NotificationPage,
    }
  }
</script>

<style scoped lang="sass">
.logo
  margin: 0 30px
.connect-logo
  cursor: pointer

.v-list-item
  color: white

.activeLang
  font-weight: bold
</style>
